module.exports = __webpack_public_path__ + "static/media/JustStarted.37eb75aa.md";